import { render } from "./purchase.vue?vue&type=template&id=1d85a4b7&scoped=true"
import script from "./purchase.vue?vue&type=script&lang=js"
export * from "./purchase.vue?vue&type=script&lang=js"

import "./purchase.vue?vue&type=style&index=0&id=1d85a4b7&lang=scss"
import "./purchase.vue?vue&type=style&index=1&id=1d85a4b7&lang=scss&scoped=true"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d85a4b7"]])

export default __exports__